import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import DependabotConfigListing from './DependabotConfigListing';
import DependabotCredentialsForm from './DependabotCredentialsForm';

const DependabotPullAndPushView = (props) => (
    <GenericPullAndPushToolView 
        {...props}
        PullCredentialForm={DependabotCredentialsForm}
        PullConfigListingView={DependabotConfigListing}
     />
);

export default DependabotPullAndPushView;
